exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sidebar[data-v-05dfb780]{overflow-y:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05dfb780","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./Resources/Private/JavaScript/components/layout/SidebarOffCanvas.vue
// module id = 75
// module chunks = 0